import { C_TO_TEMPERATURE_UNITS_VALUES } from "../pages/admin-details/account/constants";

export const convertTemperature = (
  valueInCelsius: number,
  to: C_TO_TEMPERATURE_UNITS_VALUES
): number => {
  switch (to) {
    case C_TO_TEMPERATURE_UNITS_VALUES.FAHRENHEIT:
      return valueInCelsius * (9 / 5) + 32;
    case C_TO_TEMPERATURE_UNITS_VALUES.CELSIUS:
    default:
      return valueInCelsius;
  }
};
export const convertToCelsiusForApi = (
  value: number,
  from: C_TO_TEMPERATURE_UNITS_VALUES
): number => {
  switch (from) {
    case C_TO_TEMPERATURE_UNITS_VALUES.FAHRENHEIT:
      return (value - 32) * (5 / 9);
    case C_TO_TEMPERATURE_UNITS_VALUES.CELSIUS:
    default:
      return value;
  }
};
